import { Box, IconButton, Skeleton, Stack } from '@mui/material';
import React from 'react';

const PayoutPlanSkeleton = () => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1}
      sx={{ width: '100%' }}
    >
      <Box
        sx={{
          borderRadius: '50%',
          p: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Skeleton variant="circular" width={24} height={24} />
      </Box>

      <Box sx={{ flex: 1 }}>
        <Skeleton
          variant="text"
          width="80%"
          height={20}
          sx={{ fontSize: '1rem' }}
        />
      </Box>

      <IconButton
        disabled
        sx={{
          borderRadius: '100px',
          padding: '4px 12px',
          backgroundColor: 'grey.100',
          border: '1px solid',
          borderColor: 'grey.200',
        }}
      >
        <Skeleton variant="text" width={40} height={16} />
      </IconButton>
    </Stack>
  );
};

export default PayoutPlanSkeleton;
